/* ============================================================
   Prime Gadgets Theme — Main JavaScript
   ============================================================ */

(function () {
  'use strict';

  /* ---- Header Scroll Effect ---- */
  const header = document.getElementById('SiteHeader');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 50);
    }, { passive: true });
  }

  /* ---- Scroll to Top ---- */
  const scrollTopBtn = document.getElementById('ScrollTop');
  if (scrollTopBtn) {
    window.addEventListener('scroll', () => {
      scrollTopBtn.classList.toggle('visible', window.scrollY > 400);
    }, { passive: true });
    scrollTopBtn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---- Mobile Navigation ---- */
  const mobileMenuBtn = document.getElementById('MobileMenuBtn');
  const mobileNav = document.getElementById('MobileNav');
  const mobileNavClose = document.getElementById('MobileNavClose');
  const mobileNavOverlay = document.getElementById('MobileNavOverlay');

  function openMobileNav() {
    if (!mobileNav) return;
    mobileNav.style.display = 'block';
    requestAnimationFrame(() => mobileNav.classList.add('open'));
    mobileNav.setAttribute('aria-hidden', 'false');
    if (mobileMenuBtn) mobileMenuBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMobileNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('open');
    setTimeout(() => { mobileNav.style.display = 'none'; }, 400);
    mobileNav.setAttribute('aria-hidden', 'true');
    if (mobileMenuBtn) mobileMenuBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (mobileMenuBtn) mobileMenuBtn.addEventListener('click', openMobileNav);
  if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);
  if (mobileNavOverlay) mobileNavOverlay.addEventListener('click', closeMobileNav);

  /* ---- Cart Drawer ---- */
  const cartDrawer = document.getElementById('CartDrawer');
  const cartToggle = document.getElementById('CartToggle');
  const cartDrawerClose = document.getElementById('CartDrawerClose');
  const cartDrawerOverlay = document.getElementById('CartDrawerOverlay');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartToggle && cartToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartToggle && cartToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (cartToggle) cartToggle.addEventListener('click', openCartDrawer);
  if (cartDrawerClose) cartDrawerClose.addEventListener('click', closeCartDrawer);
  if (cartDrawerOverlay) cartDrawerOverlay.addEventListener('click', closeCartDrawer);

  /* ---- Fetch & Render Cart ---- */
  async function fetchCart() {
    try {
      const resp = await fetch('/cart.js');
      const cart = await resp.json();
      renderCartDrawer(cart);
    } catch (err) {
      console.warn('Cart fetch failed:', err);
    }
  }

  function renderCartDrawer(cart) {
    const itemsEl = document.getElementById('CartDrawerItems');
    const subtotalEl = document.getElementById('CartDrawerSubtotal');
    const countEl = document.getElementById('CartCount');

    if (countEl) {
      countEl.textContent = cart.item_count;
      countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
    }

    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.total_price);
    }

    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = `
        <div style="text-align:center;padding:40px 20px;">
          <div style="font-size:3rem;margin-bottom:12px;">🛒</div>
          <p style="color:var(--color-text-muted);">Your cart is empty</p>
          <a href="/collections/all" class="btn btn--cod btn--sm" style="margin-top:16px;display:inline-flex;">Shop Now</a>
        </div>`;
      return;
    }

    itemsEl.innerHTML = cart.items.map(item => `
      <div class="cart-item" id="CartDrawerItem-${item.key}">
        <img class="cart-item__img" src="${item.image || '//:0'}" alt="${escapeHtml(item.title)}">
        <div class="cart-item__info">
          <div class="cart-item__title">${escapeHtml(item.product_title)}</div>
          ${item.variant_title !== 'Default Title' ? `<div style="font-size:0.75rem;color:var(--color-text-muted);margin-bottom:4px;">${escapeHtml(item.variant_title)}</div>` : ''}
          <div class="cart-item__price">${formatMoney(item.line_price)}</div>
          <div class="cart-item__qty">
            <button class="qty-btn" data-key="${item.key}" data-qty="${item.quantity - 1}" aria-label="Decrease">−</button>
            <span class="qty-num">${item.quantity}</span>
            <button class="qty-btn" data-key="${item.key}" data-qty="${item.quantity + 1}" aria-label="Increase">+</button>
          </div>
        </div>
        <button class="cart-remove" data-key="${item.key}" aria-label="Remove item" style="align-self:flex-start;margin-top:4px;">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
      </div>
    `).join('');

    // Bind qty and remove buttons
    itemsEl.querySelectorAll('.qty-btn').forEach(btn => {
      btn.addEventListener('click', () => updateCartItem(btn.dataset.key, parseInt(btn.dataset.qty)));
    });
    itemsEl.querySelectorAll('.cart-remove').forEach(btn => {
      btn.addEventListener('click', () => updateCartItem(btn.dataset.key, 0));
    });
  }

  async function updateCartItem(key, quantity) {
    try {
      const resp = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const cart = await resp.json();
      renderCartDrawer(cart);
    } catch (err) {
      console.warn('Cart update failed:', err);
    }
  }

  /* ---- Add to Cart (product cards) ---- */
  document.addEventListener('submit', async function (e) {
    const form = e.target.closest('.product-card__form');
    if (!form) return;
    e.preventDefault();

    const formData = new FormData(form);
    const submitBtn = form.querySelector('button[type="submit"]');
    const originalText = submitBtn ? submitBtn.innerHTML : '';

    if (submitBtn) {
      submitBtn.innerHTML = '<span style="display:inline-block;animation:spin 0.6s linear infinite">⟳</span> Adding...';
      submitBtn.disabled = true;
    }

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });
      const cart = await fetch('/cart.js').then(r => r.json());
      renderCartDrawer(cart);
      openCartDrawer();
    } catch (err) {
      console.warn('Add to cart failed:', err);
    } finally {
      if (submitBtn) {
        setTimeout(() => {
          submitBtn.innerHTML = '✅ Added!';
          setTimeout(() => {
            submitBtn.innerHTML = originalText;
            submitBtn.disabled = false;
          }, 1500);
        }, 300);
      }
    }
  });

  /* ---- Product Page ---- */
  // Gallery thumbnails
  const galleryThumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImage = document.getElementById('ProductMainImage');

  galleryThumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      galleryThumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImage) {
        mainImage.src = thumb.dataset.imageUrl;
      }
    });
  });

  // Quantity Selector
  const qtyDecrease = document.getElementById('QtyDecrease');
  const qtyIncrease = document.getElementById('QtyIncrease');
  const qtyInput = document.getElementById('ProductQty');

  if (qtyDecrease && qtyInput) {
    qtyDecrease.addEventListener('click', () => {
      const val = parseInt(qtyInput.value);
      if (val > 1) qtyInput.value = val - 1;
    });
  }
  if (qtyIncrease && qtyInput) {
    qtyIncrease.addEventListener('click', () => {
      const val = parseInt(qtyInput.value);
      qtyInput.value = val + 1;
    });
  }

  // Add to Cart (product page)
  const productAddToCartBtn = document.getElementById('ProductAddToCart');
  const productForm = document.getElementById('ProductForm');
  if (productAddToCartBtn && productForm) {
    productAddToCartBtn.addEventListener('click', async () => {
      const variantId = document.getElementById('ProductVariantId')?.value;
      const qty = qtyInput?.value || 1;
      const originalHTML = productAddToCartBtn.innerHTML;
      productAddToCartBtn.innerHTML = '⟳ Adding...';
      productAddToCartBtn.disabled = true;

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: parseInt(qty) })
        });
        const cart = await fetch('/cart.js').then(r => r.json());
        renderCartDrawer(cart);
        openCartDrawer();
        productAddToCartBtn.innerHTML = '✅ Added to Cart!';
        setTimeout(() => {
          productAddToCartBtn.innerHTML = originalHTML;
          productAddToCartBtn.disabled = false;
        }, 2000);
      } catch (err) {
        productAddToCartBtn.innerHTML = '❌ Error. Try again';
        setTimeout(() => {
          productAddToCartBtn.innerHTML = originalHTML;
          productAddToCartBtn.disabled = false;
        }, 2000);
      }
    });
  }

  // Pay Now — adds to cart then redirects straight to checkout
  function wirePayNowButton(btn) {
    if (!btn) return;
    btn.addEventListener('click', async () => {
      const variantId = document.getElementById('ProductVariantId')?.value;
      if (!variantId) return;
      const qty = qtyInput?.value || 1;
      const originalHTML = btn.innerHTML;
      btn.innerHTML = '<span style="display:inline-block;animation:spin 0.6s linear infinite">⟳</span> Redirecting to checkout...';
      btn.disabled = true;

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: parseInt(qty) })
        });
        window.location.href = '/checkout';
      } catch (err) {
        btn.innerHTML = '❌ Something went wrong. Try again';
        btn.disabled = false;
        setTimeout(() => { btn.innerHTML = originalHTML; }, 2000);
      }
    });
  }
  wirePayNowButton(document.getElementById('ProductPayNowBtn'));
  wirePayNowButton(document.getElementById('StickyPayNowBtn'));

  // Urgency Countdown — persists for the session so it feels real, not reset on every reload
  const countdownEl = document.getElementById('UrgencyCountdownTime');
  if (countdownEl) {
    const STORAGE_KEY = 'pg_deal_ends_' + (window.location.pathname || 'product');
    let dealEndsAt = parseInt(sessionStorage.getItem(STORAGE_KEY), 10);
    const DEAL_WINDOW_MS = 2 * 60 * 60 * 1000; // 2 hours
    if (!dealEndsAt || dealEndsAt < Date.now()) {
      dealEndsAt = Date.now() + DEAL_WINDOW_MS;
      sessionStorage.setItem(STORAGE_KEY, String(dealEndsAt));
    }
    function tickCountdown() {
      const remaining = Math.max(0, dealEndsAt - Date.now());
      const h = String(Math.floor(remaining / 3600000)).padStart(2, '0');
      const m = String(Math.floor((remaining % 3600000) / 60000)).padStart(2, '0');
      const s = String(Math.floor((remaining % 60000) / 1000)).padStart(2, '0');
      countdownEl.textContent = `${h}:${m}:${s}`;
      if (remaining <= 0) {
        dealEndsAt = Date.now() + DEAL_WINDOW_MS;
        sessionStorage.setItem(STORAGE_KEY, String(dealEndsAt));
      }
    }
    tickCountdown();
    setInterval(tickCountdown, 1000);
  }

  // Live Viewers — subtle, believable fluctuation
  const viewersCountEl = document.getElementById('UrgencyViewersCount');
  if (viewersCountEl) {
    setInterval(() => {
      const current = parseInt(viewersCountEl.textContent, 10) || 14;
      const delta = Math.floor(Math.random() * 5) - 2; // -2..+2
      const next = Math.min(38, Math.max(8, current + delta));
      viewersCountEl.textContent = next;
    }, 4000);
  }

  // Sticky Pay Now Bar — appears once the main CTA scrolls out of view
  const stickyBuyBar = document.getElementById('StickyBuyBar');
  const productCTAWrap = document.getElementById('ProductCTAWrap');
  if (stickyBuyBar && productCTAWrap && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          stickyBuyBar.classList.toggle('is-visible', show);
          document.body.classList.toggle('has-sticky-buy-bar', show);
        });
      },
      { threshold: 0 }
    );
    observer.observe(productCTAWrap);
  }

  // Pincode Check
  const pincodeInput = document.getElementById('PincodeInput');
  const pincodeCheck = document.getElementById('PincodeCheck');
  const pincodeResult = document.getElementById('PincodeResult');

  if (pincodeCheck && pincodeInput && pincodeResult) {
    pincodeCheck.addEventListener('click', () => {
      const pin = pincodeInput.value.trim();
      if (!/^\d{6}$/.test(pin)) {
        pincodeResult.innerHTML = '<span style="color:var(--color-red);">Please enter a valid 6-digit pincode.</span>';
        return;
      }
      pincodeResult.innerHTML = '<span style="color:var(--color-text-muted);">Checking...</span>';
      setTimeout(() => {
        pincodeResult.innerHTML = `
          <div style="color:var(--color-green);font-weight:600;">✅ Delivery available at ${pin}</div>
          <div style="color:var(--color-text-muted);margin-top:4px;">Expected delivery: <strong style="color:var(--color-text);">2-5 business days</strong> | COD Available ✓</div>
        `;
      }, 800);
    });
    pincodeInput.addEventListener('keypress', e => {
      if (e.key === 'Enter') pincodeCheck.click();
    });
  }

  // Variant selectors
  const variantBtns = document.querySelectorAll('[data-variant-option]');
  variantBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const optionName = btn.dataset.variantOption;
      document.querySelectorAll(`[data-variant-option="${optionName}"]`).forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });

  /* ---- Collection Sort ---- */
  const collectionSort = document.getElementById('CollectionSort');
  if (collectionSort) {
    const params = new URLSearchParams(window.location.search);
    const currentSort = params.get('sort_by') || 'manual';
    collectionSort.value = currentSort;
    collectionSort.addEventListener('change', () => {
      params.set('sort_by', collectionSort.value);
      window.location.search = params.toString();
    });
  }

  /* ---- Cart Page Quantity Controls ---- */
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.qty-btn[data-action]');
    if (!btn) return;
    const key = btn.dataset.itemKey;
    const action = btn.dataset.action;
    const qtySpan = btn.closest('.cart-item__qty')?.querySelector('.qty-num');
    if (!qtySpan) return;

    let qty = parseInt(qtySpan.textContent);
    if (action === 'increase') qty++;
    else if (action === 'decrease') qty = Math.max(0, qty - 1);

    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      window.location.reload();
    } catch (err) { console.warn(err); }
  });

  // Cart remove buttons
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.cart-remove[data-item-key]');
    if (!btn) return;
    const key = btn.dataset.itemKey;
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      window.location.reload();
    } catch (err) { console.warn(err); }
  });

  /* ---- Newsletter Popup ---- */
  const popup = document.getElementById('NewsletterPopup');
  const popupClose = document.getElementById('PopupClose');
  const POPUP_KEY = 'pg_popup_shown';

  if (popup && !sessionStorage.getItem(POPUP_KEY)) {
    setTimeout(() => {
      popup.style.display = 'flex';
      sessionStorage.setItem(POPUP_KEY, '1');
    }, 8000);
  }
  if (popupClose) {
    popupClose.addEventListener('click', () => {
      if (popup) popup.style.display = 'none';
    });
  }
  if (popup) {
    popup.addEventListener('click', e => {
      if (e.target === popup.querySelector('.newsletter-popup__overlay')) {
        popup.style.display = 'none';
      }
    });
  }

  /* ---- Wishlist (localStorage) ---- */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.product-card__wishlist');
    if (!btn) return;
    const productId = btn.dataset.productId;
    if (!productId) return;
    const wishlist = JSON.parse(localStorage.getItem('pg_wishlist') || '[]');
    const idx = wishlist.indexOf(productId);
    if (idx === -1) {
      wishlist.push(productId);
      btn.style.color = 'var(--color-orange)';
      btn.style.borderColor = 'var(--color-orange)';
    } else {
      wishlist.splice(idx, 1);
      btn.style.color = '';
      btn.style.borderColor = '';
    }
    localStorage.setItem('pg_wishlist', JSON.stringify(wishlist));
  });

  // Set initial wishlist state
  const wishlistBtns = document.querySelectorAll('.product-card__wishlist');
  const wishlistData = JSON.parse(localStorage.getItem('pg_wishlist') || '[]');
  wishlistBtns.forEach(btn => {
    if (wishlistData.includes(btn.dataset.productId)) {
      btn.style.color = 'var(--color-orange)';
      btn.style.borderColor = 'var(--color-orange)';
    }
  });

  /* ---- Intersection Observer (lazy animations) ---- */
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.stagger > *').forEach((el, i) => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(30px)';
    el.style.transition = `opacity 0.5s ease ${i * 0.05}s, transform 0.5s ease ${i * 0.05}s`;
    observer.observe(el);
  });

  /* ---- Utility Functions ---- */
  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.appendChild(document.createTextNode(str || ''));
    return div.innerHTML;
  }

  /* ---- Keyboard Navigation ---- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCartDrawer();
      closeMobileNav();
      if (popup) popup.style.display = 'none';
    }
  });

  /* ---- Initialize ---- */
  fetchCart(); // Sync cart count on load

  // Add spin keyframe
  const style = document.createElement('style');
  style.textContent = '@keyframes spin { to { transform: rotate(360deg); } }';
  document.head.appendChild(style);

})();

/* ============================================================
   MOBILE PATCH — appended to theme.js
   ============================================================ */

/* ---- Mobile Search Bar Toggle ---- */
(function () {
  const mobileSearchBtn = document.getElementById('MobileSearchBtn');
  const mobileSearchBar = document.getElementById('MobileSearchBar');
  const mobileSearchInput = document.getElementById('MobileSearchInput');

  if (mobileSearchBtn && mobileSearchBar) {
    mobileSearchBtn.addEventListener('click', function () {
      const isOpen = mobileSearchBar.classList.toggle('open');
      mobileSearchBar.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
      mobileSearchBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen && mobileSearchInput) {
        setTimeout(() => mobileSearchInput.focus(), 300);
      }
    });
  }

  /* Close mobile search on Escape */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mobileSearchBar && mobileSearchBar.classList.contains('open')) {
      mobileSearchBar.classList.remove('open');
      mobileSearchBar.setAttribute('aria-hidden', 'true');
      if (mobileSearchBtn) mobileSearchBtn.setAttribute('aria-expanded', 'false');
    }
  });
})();

/* ---- Wishlist Button (JS-powered, no /wishlist page needed) ---- */
(function () {
  const wishlistBtn = document.getElementById('WishlistBtn');
  const wishlistIcon = document.getElementById('WishlistIcon');
  const WISHLIST_KEY = 'pg_wishlist';
  const toast = document.getElementById('WishlistToast');

  function showWishlistToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('show');
    setTimeout(() => toast.classList.remove('show'), 2800);
  }

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch { return []; }
  }

  function refreshWishlistIcon() {
    const wishlist = getWishlist();
    if (!wishlistIcon) return;
    if (wishlist.length > 0) {
      wishlistIcon.setAttribute('fill', 'var(--color-orange)');
      wishlistIcon.setAttribute('stroke', 'var(--color-orange)');
    } else {
      wishlistIcon.setAttribute('fill', 'none');
      wishlistIcon.setAttribute('stroke', 'currentColor');
    }
  }

  if (wishlistBtn) {
    wishlistBtn.addEventListener('click', function () {
      const wishlist = getWishlist();
      if (wishlist.length === 0) {
        showWishlistToast('💔 Your wishlist is empty — tap ♡ on products to save them!');
      } else {
        showWishlistToast(`❤️ ${wishlist.length} item${wishlist.length > 1 ? 's' : ''} in wishlist`);
      }
    });
  }
  refreshWishlistIcon();

  /* Update icon when products are wishlisted */
  document.addEventListener('click', function (e) {
    if (e.target.closest('.product-card__wishlist')) {
      setTimeout(refreshWishlistIcon, 50);
    }
  });
})();

/* ---- Mobile Collection Filter Toggle ---- */
(function () {
  const filterBtn = document.querySelector('.filter-mobile-toggle');
  const filterPanel = document.querySelector('.collection-filters');
  if (filterBtn && filterPanel) {
    filterBtn.addEventListener('click', function () {
      const isOpen = filterPanel.classList.toggle('mobile-open');
      filterBtn.textContent = isOpen ? '✕ Hide Filters' : '⚙️ Filter & Sort';
      filterBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }
})();

/* ---- Fix body scroll when cart / nav is open ---- */
(function () {
  // Prevent overscroll behind modals on iOS
  function preventBodyScroll(prevent) {
    if (prevent) {
      document.body.style.position = 'fixed';
      document.body.style.top = `-${window.scrollY}px`;
      document.body.style.width = '100%';
    } else {
      const scrollY = document.body.style.top;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      if (scrollY) window.scrollTo(0, -parseInt(scrollY || '0', 10));
    }
  }

  // Observe cart drawer
  const cartDrawerEl = document.getElementById('CartDrawer');
  if (cartDrawerEl) {
    const cartObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'class') {
          const isOpen = cartDrawerEl.classList.contains('open');
          if (window.innerWidth <= 768) preventBodyScroll(isOpen);
        }
      });
    });
    cartObserver.observe(cartDrawerEl, { attributes: true });
  }
})();

/* ============================================================
   MOBILE CONVERSION FIX PATCH v2 — primegadgets
   Fixes: iOS scroll lock, double-tap zoom, input zoom,
   cart drawer slide-up, touch swipe on gallery, pincode
   auto-format, and section header button wrapping.
   ============================================================ */

(function () {
  'use strict';

  /* ---- FIX 1: iOS scroll lock (replaces broken position:fixed method) ---- */
  // The original code uses position:fixed which breaks scroll position on iOS.
  // This replaces it with a correct implementation using scroll-position save/restore.
  let _scrollY = 0;

  function lockBodyScroll() {
    _scrollY = window.scrollY;
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = -_scrollY + 'px';
    document.body.style.width = '100%';
  }

  function unlockBodyScroll() {
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, _scrollY);
  }

  // Patch the cart drawer open/close to use fixed scroll lock
  const _cartDrawerEl = document.getElementById('CartDrawer');
  const _cartToggleEl = document.getElementById('CartToggle');
  const _cartDrawerCloseEl = document.getElementById('CartDrawerClose');
  const _cartOverlayEl = document.getElementById('CartDrawerOverlay');

  function _openCart() {
    if (!_cartDrawerEl) return;
    _cartDrawerEl.classList.add('open');
    if (_cartToggleEl) _cartToggleEl.setAttribute('aria-expanded', 'true');
    lockBodyScroll();
  }
  function _closeCart() {
    if (!_cartDrawerEl) return;
    _cartDrawerEl.classList.remove('open');
    if (_cartToggleEl) _cartToggleEl.setAttribute('aria-expanded', 'false');
    unlockBodyScroll();
  }

  // Patch mobile nav to use fixed scroll lock too
  const _mobileNavEl = document.getElementById('MobileNav');
  const _mobileMenuBtnEl = document.getElementById('MobileMenuBtn');
  const _mobileNavCloseEl = document.getElementById('MobileNavClose');
  const _mobileNavOverlayEl = document.getElementById('MobileNavOverlay');

  function _openNav() {
    if (!_mobileNavEl) return;
    _mobileNavEl.style.display = 'block';
    requestAnimationFrame(() => _mobileNavEl.classList.add('open'));
    _mobileNavEl.setAttribute('aria-hidden', 'false');
    if (_mobileMenuBtnEl) _mobileMenuBtnEl.setAttribute('aria-expanded', 'true');
    lockBodyScroll();
  }
  function _closeNav() {
    if (!_mobileNavEl) return;
    _mobileNavEl.classList.remove('open');
    setTimeout(() => {
      if (!_mobileNavEl.classList.contains('open')) _mobileNavEl.style.display = 'none';
    }, 400);
    _mobileNavEl.setAttribute('aria-hidden', 'true');
    if (_mobileMenuBtnEl) _mobileMenuBtnEl.setAttribute('aria-expanded', 'false');
    unlockBodyScroll();
  }

  // Replace old event listeners
  if (_mobileMenuBtnEl) {
    const old = _mobileMenuBtnEl.cloneNode(true);
    _mobileMenuBtnEl.parentNode.replaceChild(old, _mobileMenuBtnEl);
    old.addEventListener('click', _openNav);
  }
  if (_mobileNavCloseEl) {
    const old = _mobileNavCloseEl.cloneNode(true);
    _mobileNavCloseEl.parentNode.replaceChild(old, _mobileNavCloseEl);
    old.addEventListener('click', _closeNav);
  }
  if (_mobileNavOverlayEl) {
    const old = _mobileNavOverlayEl.cloneNode(true);
    _mobileNavOverlayEl.parentNode.replaceChild(old, _mobileNavOverlayEl);
    old.addEventListener('click', _closeNav);
  }

  if (_cartToggleEl) {
    const old = _cartToggleEl.cloneNode(true);
    _cartToggleEl.parentNode.replaceChild(old, _cartToggleEl);
    old.addEventListener('click', _openCart);
  }
  if (_cartDrawerCloseEl) {
    const old = _cartDrawerCloseEl.cloneNode(true);
    _cartDrawerCloseEl.parentNode.replaceChild(old, _cartDrawerCloseEl);
    old.addEventListener('click', _closeCart);
  }
  if (_cartOverlayEl) {
    const old = _cartOverlayEl.cloneNode(true);
    _cartOverlayEl.parentNode.replaceChild(old, _cartOverlayEl);
    old.addEventListener('click', _closeCart);
  }

  // Escape key — also close newsletter popup
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      _closeCart();
      _closeNav();
      const popup = document.getElementById('NewsletterPopup');
      if (popup) popup.style.display = 'none';
    }
  });

  /* ---- FIX 2: Pincode input — numeric keyboard on mobile, auto-format ---- */
  const pincodeInputEl = document.getElementById('PincodeInput');
  if (pincodeInputEl) {
    pincodeInputEl.setAttribute('inputmode', 'numeric');
    pincodeInputEl.setAttribute('pattern', '[0-9]*');
    pincodeInputEl.addEventListener('input', function () {
      // Strip non-digits
      this.value = this.value.replace(/\D/g, '').slice(0, 6);
    });
  }

  /* ---- FIX 3: Product gallery — touch swipe support ---- */
  const galleryMain = document.getElementById('ProductGalleryMain');
  const thumbBtns = document.querySelectorAll('.product-gallery__thumb');
  if (galleryMain && thumbBtns.length > 1) {
    let touchStartX = 0;
    let touchEndX = 0;
    let currentThumbIdx = 0;

    galleryMain.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    galleryMain.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) < 40) return; // too small, ignore

      if (diff > 0) {
        // Swipe left → next image
        currentThumbIdx = Math.min(currentThumbIdx + 1, thumbBtns.length - 1);
      } else {
        // Swipe right → previous image
        currentThumbIdx = Math.max(currentThumbIdx - 1, 0);
      }
      thumbBtns[currentThumbIdx].click();
      thumbBtns.forEach(t => t.classList.remove('active'));
      thumbBtns[currentThumbIdx].classList.add('active');
    }, { passive: true });
  }

  /* ---- FIX 4: Prevent double-tap zoom on CTA buttons (iOS) ---- */
  document.querySelectorAll('.btn--cod, .btn--paynow, .btn--primary').forEach(function (btn) {
    btn.addEventListener('touchend', function (e) {
      e.preventDefault();
      this.click();
    });
  });

  /* ---- FIX 5: Newsletter popup — close on overlay tap (mobile) ---- */
  const popupEl = document.getElementById('NewsletterPopup');
  if (popupEl) {
    const overlayEl = popupEl.querySelector('.newsletter-popup__overlay');
    if (overlayEl) {
      overlayEl.addEventListener('click', function () {
        popupEl.style.display = 'none';
      });
      // Also close on tap outside the box on mobile
      overlayEl.addEventListener('touchend', function (e) {
        e.preventDefault();
        popupEl.style.display = 'none';
      });
    }
  }

  /* ---- FIX 6: Announce bar — pause on touch (mobile battery saver) ---- */
  const annTrack = document.querySelector('.announcement-bar__track');
  if (annTrack) {
    annTrack.addEventListener('touchstart', function () {
      annTrack.style.animationPlayState = 'paused';
    }, { passive: true });
    annTrack.addEventListener('touchend', function () {
      annTrack.style.animationPlayState = 'running';
    }, { passive: true });
  }

  /* ---- FIX 7: Section header "View All" button — don't clip on mobile ---- */
  document.querySelectorAll('.section__header').forEach(function (el) {
    el.style.flexWrap = 'wrap';
  });

  /* ---- FIX 8: Cart drawer — swipe down to close on mobile ---- */
  const cartDrawerInner = document.querySelector('.cart-drawer__inner');
  if (cartDrawerInner) {
    let cdTouchStartY = 0;
    cartDrawerInner.addEventListener('touchstart', function (e) {
      cdTouchStartY = e.touches[0].clientY;
    }, { passive: true });
    cartDrawerInner.addEventListener('touchend', function (e) {
      const diff = e.changedTouches[0].clientY - cdTouchStartY;
      if (diff > 80 && _cartDrawerEl && _cartDrawerEl.classList.contains('open')) {
        // Swipe down > 80px closes the drawer
        _closeCart();
      }
    }, { passive: true });
  }

  /* ---- FIX 9: Sticky buy bar — ensure it doesn't cover checkout button ---- */
  // The sticky bar only shows when main CTA is above the fold.
  // Extra guard: hide it on the /cart and /checkout pages.
  if (window.location.pathname === '/cart' || window.location.pathname.startsWith('/checkouts')) {
    const stickyBar = document.getElementById('StickyBuyBar');
    if (stickyBar) stickyBar.style.display = 'none';
  }

  /* ---- FIX 10: Mobile menu — swipe left to close ---- */
  const mobileNavPanel = document.querySelector('.mobile-nav__panel');
  if (mobileNavPanel) {
    let mnTouchStartX = 0;
    mobileNavPanel.addEventListener('touchstart', function (e) {
      mnTouchStartX = e.touches[0].clientX;
    }, { passive: true });
    mobileNavPanel.addEventListener('touchend', function (e) {
      const diff = mnTouchStartX - e.changedTouches[0].clientX;
      if (diff > 60) {
        // Swipe left closes the menu
        _closeNav();
      }
    }, { passive: true });
  }

})();

/* ============================================================
   CUSTOMER REVIEWS — appended to theme.js
   Handles the "Write a Review" form on the Customer Reviews
   section. Submitted reviews are stored in localStorage, scoped
   per-section-per-template, so Home page reviews and Product
   page reviews are tracked separately. The fake starting count
   (from the theme editor) is never modified — only the +1s from
   real submissions are stored and added on top of it.
   ============================================================ */
(function () {
  function escapeHtml(str) {
    const div = document.createElement('div');
    div.appendChild(document.createTextNode(str || ''));
    return div.innerHTML;
  }

  function storageKey(scope) {
    return 'pg_reviews_' + scope;
  }

  function loadReviews(scope) {
    try {
      return JSON.parse(localStorage.getItem(storageKey(scope)) || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveReviews(scope, reviews) {
    try {
      localStorage.setItem(storageKey(scope), JSON.stringify(reviews));
    } catch (e) {
      /* localStorage unavailable — fail silently, review still shows for this pageview */
    }
  }

  function starString(rating) {
    const full = Math.floor(rating);
    const half = rating - full >= 0.5;
    let s = '★'.repeat(full);
    if (half) s += '½';
    return s || '★';
  }

  function renderCard(review) {
    const card = document.createElement('div');
    card.className = 'testimonial-card';
    const stars = '★'.repeat(review.rating);
    const initial = (review.name || 'C').trim().charAt(0).toUpperCase() || 'C';
    card.innerHTML =
      '<div class="testimonial-card__stars" aria-label="' + review.rating + ' stars">' + stars + '</div>' +
      '<p class="testimonial-card__text">"' + escapeHtml(review.text) + '"</p>' +
      '<div class="testimonial-card__author">' +
        '<div class="testimonial-card__avatar" aria-hidden="true">' + escapeHtml(initial) + '</div>' +
        '<div>' +
          '<div class="testimonial-card__name">' + escapeHtml(review.name) + '</div>' +
          '<div class="testimonial-card__verified">' +
            '<svg width="12" height="12" viewBox="0 0 24 24" fill="var(--color-green)"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>' +
            'Verified Buyer' +
          '</div>' +
        '</div>' +
      '</div>';
    return card;
  }

  function updateSummary(sectionEl, baseCount, baseRatingTenths, storedReviews) {
    const sectionId = sectionEl.id.replace('CustomerReviews-', '');
    const countEl = document.getElementById('ReviewsCount-' + sectionId);
    const starsEl = document.getElementById('ReviewsAvgStars-' + sectionId);
    const ratingEl = document.getElementById('ReviewsAvgRating-' + sectionId);

    const newCount = baseCount + storedReviews.length;
    if (countEl) countEl.textContent = newCount;

    // Weight the base rating heavily (it represents the "existing" reviews)
    // so a handful of real submissions nudges the average without swinging it wildly.
    let ratingSum = (baseRatingTenths / 10) * baseCount;
    storedReviews.forEach(function (r) { ratingSum += r.rating; });
    const avg = baseCount + storedReviews.length > 0 ? ratingSum / (baseCount + storedReviews.length) : (baseRatingTenths / 10);
    const avgRounded = Math.round(avg * 10) / 10;

    if (starsEl) starsEl.textContent = starString(avg);
    if (ratingEl) ratingEl.textContent = avgRounded.toFixed(1);
  }

  document.querySelectorAll('[data-review-section]').forEach(function (sectionEl) {
    const scope = sectionEl.getAttribute('data-scope');
    const baseCount = parseInt(sectionEl.getAttribute('data-base-count'), 10) || 0;
    const baseRatingTenths = parseInt(sectionEl.getAttribute('data-base-rating'), 10) || 45;
    const grid = sectionEl.querySelector('[id^="ReviewsGrid-"]');
    const form = sectionEl.querySelector('form.review-form');
    const note = sectionEl.querySelector('.review-form__note');
    const starsInput = sectionEl.querySelector('[id^="ReviewStarsInput-"]');
    const ratingHidden = sectionEl.querySelector('[id^="ReviewRatingValue-"]');

    const stored = loadReviews(scope);

    // Render previously-submitted reviews (most recent first) on top of the curated ones
    stored.slice().reverse().forEach(function (r) {
      if (grid) grid.insertBefore(renderCard(r), grid.firstChild);
    });

    updateSummary(sectionEl, baseCount, baseRatingTenths, stored);

    // Star picker interaction
    if (starsInput) {
      const starBtns = starsInput.querySelectorAll('.review-form__star');
      function setActiveStars(value) {
        starBtns.forEach(function (btn) {
          const v = parseInt(btn.getAttribute('data-value'), 10);
          btn.classList.toggle('active', v <= value);
          btn.setAttribute('aria-checked', v === value ? 'true' : 'false');
        });
        if (ratingHidden) ratingHidden.value = value;
      }
      starBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          setActiveStars(parseInt(btn.getAttribute('data-value'), 10));
        });
      });
      setActiveStars(5); // default to 5 stars
    }

    // Form submission
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        const nameInput = form.querySelector('input[name="name"]');
        const textInput = form.querySelector('textarea[name="text"]');
        const rating = parseInt((ratingHidden && ratingHidden.value) || '5', 10);

        const name = (nameInput && nameInput.value || '').trim();
        const text = (textInput && textInput.value || '').trim();

        if (!name || !text) {
          if (note) {
            note.textContent = 'Please add your name and a short review before submitting.';
            note.classList.add('error');
          }
          return;
        }

        const review = { name: name, text: text, rating: rating, ts: Date.now() };
        const current = loadReviews(scope);
        current.push(review);
        saveReviews(scope, current);

        if (grid) grid.insertBefore(renderCard(review), grid.firstChild);
        updateSummary(sectionEl, baseCount, baseRatingTenths, current);

        form.reset();
        if (starsInput) {
          starsInput.querySelectorAll('.review-form__star').forEach(function (btn) {
            const v = parseInt(btn.getAttribute('data-value'), 10);
            btn.classList.toggle('active', v <= 5);
          });
          if (ratingHidden) ratingHidden.value = 5;
        }

        if (note) {
          note.textContent = '🎉 Thanks! Your review has been posted.';
          note.classList.remove('error');
        }
      });
    }
  });
})();
